import { render, staticRenderFns } from "./DormCard.vue?vue&type=template&id=dd321670&scoped=true&"
import script from "./DormCard.vue?vue&type=script&lang=js&"
export * from "./DormCard.vue?vue&type=script&lang=js&"
import style0 from "./DormCard.vue?vue&type=style&index=0&id=dd321670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd321670",
  null
  
)

export default component.exports